import { Injectable } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private titleService: Title, private meta: Meta) { }

  setMetaData(
    title: string,
    description: string,
    imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png',
    url = 'https://onlyusedtesla.com'
  ): void {
    this.clearMetaTags();
    this.removeCanonicalLink();

    this.titleService.setTitle(title);
    const metaTags: MetaDefinition[] = [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: imageUrl },
      { property: 'og:url', content: url },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: imageUrl },
      { name: 'author', content: 'Only Used Tesla' },
      { name: 'keywords', content: 'Used Tesla, Buy Tesla USA, Tesla Model 3, Tesla Model Y, Tesla Model X, Tesla Model S, Tesla Cybertruck, Used Electric Cars, Affordable Tesla, Certified Tesla' },
    ];

    metaTags.forEach((tag) => this.meta.addTag(tag));

    this.setCanonicalLink(url);
  }

  private clearMetaTags(): void {
    const tagsToRemove = [
      'description',
      'og:title',
      'og:description',
      'og:image',
      'og:url',
      'og:type',
      'twitter:card',
      'twitter:title',
      'twitter:description',
      'twitter:image',
      'author',
      'keywords',
    ];

    tagsToRemove.forEach(tag => {
      this.meta.removeTag(`name='${tag}'`);
      this.meta.removeTag(`property='${tag}'`);
    });
  }

  private setCanonicalLink(url: string): void {
    const link: HTMLLinkElement = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    document.head.appendChild(link);
  }

  private removeCanonicalLink(): void {
    const existing = document.querySelector(`link[rel='canonical']`);
    if (existing) {
      existing.remove();
    }
  }
}
